import { render, StrictMode, useRef, useEffect } from "@wordpress/element";
import { Dropdown } from "@swt/ui";
import { ChevronRightIcon } from "@swt/icons";
import cx from "classnames";

export function swtMainnavigationFlyout( elm: HTMLElement ) {
	const linkElm = elm.querySelector( "a" );

	if ( linkElm && elm.hasAttribute( "config" ) ) {
		let config = null;
		const s = elm.getAttribute( "config" );
		if ( s ) {
			config = JSON.parse( s );
		}

		if ( config ) {
			linkElm.onclick = ( e ) => {
				e.preventDefault();
				e.stopPropagation();

				render(
					<StrictMode>
						<Flyout linkElm={ linkElm } items={ config! }></Flyout>
					</StrictMode>,
					elm
				);
			};
		}
	}
}

function Flyout( props: {
	linkElm: HTMLAnchorElement,
	items: Array<{ href: string, title: string, text?: string, active: boolean, icon?: string }>
} ) {
	const buttonRef = useRef<any>();
	const buttonCss = props.linkElm.getAttribute( "class" );
	const buttonHtml = props.linkElm.innerHTML;

	useEffect( () => {
		if ( buttonRef.current ) {
			buttonRef.current.click();
		}
	}, [ buttonRef ] );

	return (
		<>
			<Dropdown placement="flyout" button={ ( { setReferenceElement } ) => (
				<Dropdown.Button className={ buttonCss + ' swt-text-body-2' } ref={ buttonRef }>
					<span ref={ setReferenceElement } dangerouslySetInnerHTML={ { __html: buttonHtml } } className="flex items-center"></span>
				</Dropdown.Button>
			) }
			>
				<Dropdown.Panel className="p-4">
					<ul className="grid gap-y-4">
						{ props.items.map( ( item ) => (
							<li key={ item.href }>
								<a href={ item.href } title={ item.title } className={ cx( " px-2 py-2 rounded-md flex items-center justify-between space-x-4 text-center cursor-pointer group", item.active ? "bg-white" : "bg-white" ) }>
									<div className="flex items-center space-x-4">
										<div className="inline-flex items-center justify-center w-10 h-10 transition duration-300 rounded-md opacity-75 text-ui-primary group-hover:opacity-100 group-hover:ease-in-out">
											<i className={ `text-xl ${ item.icon }` } aria-hidden="true"></i>
										</div>
										<p className={ cx( "relative text-ui-700 swt-text-body-1 whitespace-nowrap" ) }>
											{ item.title }
											{ item.active && <span className={ cx(
												"absolute h-px left-0 right-0 -bottom-px bg-gradient-to-r from-ui-primary/30 via-ui-primary to-ui-primary/30"
											) }></span>
											}
										</p>
									</div>
									<ChevronRightIcon className="transition-opacity duration-300 opacity-0 group-hover:opacity-100 text-ui-700"></ChevronRightIcon>
								</a>
							</li>
						) ) }
					</ul>
				</Dropdown.Panel>
			</Dropdown>
		</>
	);
}
